import script from "./GatedDownload.vue?vue&type=script&lang=ts&setup=true"
export * from "./GatedDownload.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__